<template>
    <div>
        <button
            class="flex w-full h-full justify-center py-2 px-4 text-sm font-medium | focus:outline-none | transition duration-150 ease-in-out"
            :class="[
                {
                    'bg-blue-500 border-transparent text-white cursor-default': primary,
                    'bg-white border-gray-300 text-gray-700': !primary,
                    'opacity-50 cursor-not-allowed': disabled,
                },
                hoverClass,
            ]"
            :disabled="disabled"
            @click.prevent="$emit('click')"
        >
            <slot />
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            primary: {
                type: Boolean,
                default: true,
            },
        },

        computed: {
            hoverClass() {
                return this.primary || this.disabled ? '' : 'hover:bg-gray-100';
            },
        },
    };
</script>
